import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import websocketPlugin from './plugin/websocket-plugin'
import userPlugin from './userModule/plugin'
import settingPlugin from './plugin/settingPlugin'
import orderPlugin from './orderModule/plugin'
import timePlugin from './plugin/timePlugin'
import menuDraftPlugin from './menuDraftModule/plugin'
import userModule from './userModule/index'
import managerModule from './managerModule/index'
import orderModule from './orderModule/index'
import statisticsModule from './statisticsModule/index'
import menuModule from '@/common/store/menuModule/index'
import menuPlugin from '@/common/store/menuModule/plugin'
import storePlugin from './plugin/store-plugin'
import menuDraftModule from './menuDraftModule/index'
import cashierModule from './cashierModule/index'
import monitorModule from './monitorModule/index'
import itemstateModule from './itemstateModule/index'
import workstationModule from './workstationModule/index'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging',
  modules: {
    cashierModule,
    monitorModule,
    userModule,
    managerModule,
    orderModule,
    statisticsModule,
    menuModule,
    menuDraftModule,
    itemstateModule,
    workstationModule
  },
  state: {
    store: null,
    socketId: null,
    connectionLog: null,
    settings: {
      fontSize: 16,
      margin: 5,
      preOrderRing: true,
      newOrderRing: true
    },
    tableNumbers: null,
    isTableNumberDirty: false,
    currentMinute: null,
    fullscreen: false,
    showVersionDialog: false,
    showWelcomeDialog: false,
    showNewVersionDialog: ''
  },
  getters: {
    storeId: state => state.store ? state.store.id : null,
    storeName: state => state.store ? state.store.name : null,
    storeBranch: state => state.store ? state.store.branch : null,
    fullStoreName: (state, getters) => getters.storeBranch
      ? getters.storeName + ' - ' + getters.storeBranch
      : getters.storeName,
    useCashier: state => state.store ? state.store.useCashier : null,
    useReceipt: state => state.store ? state.store.useReceipt : null,
    useMonitor: state => state.store ? state.store.useMonitor : null
  },
  mutations,
  actions,
  plugins: [
    settingPlugin,
    websocketPlugin,
    userPlugin,
    menuPlugin,
    orderPlugin,
    timePlugin,
    storePlugin,
    menuDraftPlugin,
    createPersistedState({
      key: 'ezmeals-state',
      paths: [
        'workstationModule.currentStation'
      ]
    })
  ]
})
